{
    "SignInWith_Title": "Anmeldung mit",
    "NAME": "SignInWith",
    "SignInWith_OtherOptions": "Andere Optionen"
}